import { NgModule } from '@angular/core';
import { DefaultComponent } from './default.component';
import { HeaderModule } from '@shared/components/header/header.module';
import { SharedModule } from '@shared/shared.module';
import { CartDonationsComponent } from './components/cart-donations/cart-donations.component';
import { CategoriesComponent } from './components/categories/categories.component';
import { ProjectBoxComponent } from './components/project-box/project-box.component';
import { EventBoxComponent } from './components/event-box/event-box.component';
import { FooterModule } from '@shared/components/footer/footer.module';
import { AuthComponent } from '@layouts/default/components/auth/auth.component';
import { RegisterComponent } from '@layouts/default/components/auth/components/register/register.component';
import { ResetPassComponent } from '@layouts/default/components/auth/components/reset-pass/reset-pass.component';
import { ConfirmEmailComponent } from '@layouts/default/components/auth/components/confirm-email/confirm-email.component';
import { LoginComponent } from '@layouts/default/components/auth/components/login/login.component';
import { LottieModule } from 'ngx-lottie';
import { OurPlanetHeroesComponent } from '@layouts/default/layouts/guest/pages/home/components/our-planet-heroes/our-planet-heroes.component';
import { RegisterCompanyComponent } from './components/auth/components/register-company/register-company.component';
import { ProjectModule } from '@layouts/default/layouts/logged/pages/project/project.module';
import { EventsModule } from '@layouts/default/layouts/logged/pages/events/events.module';
import { EventConvertModalComponent } from '@layouts/default/components/event-convert-to-project-modal/event-convert-to-project-modal.component';
import { EventsCarouselComponent } from '@layouts/default/layouts/guest/pages/home/components/events-carousel/events-carousel.component';
import { EventTooltipComponent } from './components/event-tooltip/event-tooltip.component';
import { ProjectTooltipComponent } from './components/project-tooltip/project-tooltip.component';
import { AmbassadorTooltipComponent } from './components/ambassador-tooltip/ambassador-tooltip.component';
import { lottiePlayerFactory } from 'src/app/app.functions';
import { GoogleSigninButtDirective } from '@shared/directives/google-sign-in-btn.directive';
import { HomepageFilteredMapComponent } from '@layouts/default/components/homepage-filtered-map/homepage-filtered-map.component';
import { MapInfoWindowAmbassadorComponent } from '@layouts/default/components/map-infowindow-ambassador/map-infowindow-ambassador.component';
import { MapInfoWindowEventComponent } from '@layouts/default/components/map-infowindow-event/map-infowindow-event.component';
import { MapInfoWindowProjectComponent } from '@layouts/default/components/map-infowindow-project/map-infowindow-project.component';
import { MatIconModule } from '@angular/material/icon';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LeafletMarkerClusterModule } from '@asymmetrik/ngx-leaflet-markercluster';
import LandingPageOpenStreetMapComponent from '@layouts/default/components/landing-page-open-street-map/landing-page-open-street-map.component';

@NgModule({
  declarations: [
    GoogleSigninButtDirective,
    DefaultComponent,
    CartDonationsComponent,
    CategoriesComponent,
    ProjectBoxComponent,
    AuthComponent,
    EventBoxComponent,
    EventConvertModalComponent,
    LoginComponent,
    RegisterComponent,
    ResetPassComponent,
    ConfirmEmailComponent,
    OurPlanetHeroesComponent,
    EventsCarouselComponent,
    RegisterCompanyComponent,
    EventTooltipComponent,
    ProjectTooltipComponent,
    AmbassadorTooltipComponent,
    HomepageFilteredMapComponent,
    MapInfoWindowAmbassadorComponent,
    MapInfoWindowEventComponent,
    MapInfoWindowProjectComponent,
    LandingPageOpenStreetMapComponent
  ],
  exports: [
    EventTooltipComponent,
    ProjectTooltipComponent,
    AmbassadorTooltipComponent,
    CartDonationsComponent,
    CategoriesComponent,
    ProjectBoxComponent,
    EventBoxComponent,
    EventConvertModalComponent,
    OurPlanetHeroesComponent,
    EventsCarouselComponent,
    HomepageFilteredMapComponent,
    MapInfoWindowAmbassadorComponent,
    MapInfoWindowEventComponent,
    MapInfoWindowProjectComponent,
    AuthComponent,
    LandingPageOpenStreetMapComponent
  ],
    imports: [
        SharedModule,
        HeaderModule,
        FooterModule,
        LottieModule.forRoot({player: lottiePlayerFactory}),
        ProjectModule,
        EventsModule,
        MatIconModule,
        LeafletModule,
        LeafletMarkerClusterModule
    ],
})
export class DefaultModule {}
